// extracted by mini-css-extract-plugin
export default {"outer":"Caption__outer___gEEUX","title":"Caption__title___Lp21u","expand":"Caption__expand___JyPHg"};